import { IconBook, IconExternalLink } from "@tabler/icons-react";
import { Link, createFileRoute } from "@tanstack/react-router";

import { PageHeader } from "@/components/page-header";
import { useDocumentTitle } from "@/lib/use-document-title";

/**
 * Ported from portal-ui/app/(support)/docs/page.tsx. The "Manual upload"
 * link to /upload was dropped after slice B of task #13 consolidated all
 * per-entity forms into the single /dashboard-upload surface — /upload
 * itself stays as a redirect for bookmark compat.
 */
const LINKS: Array<{ href: string; label: string; meta: string }> = [
  {
    href: "/dashboard-upload",
    label: "Upload dashboard",
    meta: "Single NEET workflow surface — manage all six entities + bulk import",
  },
];

export const Route = createFileRoute("/_app/_support/docs")({
  component: Docs,
});

function Docs() {
  useDocumentTitle("Docs");
  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col gap-6">
      <PageHeader eyebrow="Admin" title="Docs" meta="Reference for admin tooling." />

      <section className="flex items-start gap-4 rounded-2xl border border-border/60 bg-card p-5 shadow-[var(--shadow-bento)]">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary ring-1 ring-inset ring-primary/20">
          <IconBook size={20} />
        </div>
        <div className="flex min-w-0 flex-col gap-1">
          <h2 className="text-base font-semibold tracking-tight">Operations guide</h2>
          <p className="text-sm leading-relaxed text-muted-foreground">
            Quick links for daily admin tasks. Refer to the project README in the repo for the full
            bootstrap, smoke-test, and runbook details.
          </p>
        </div>
      </section>

      <ul className="flex flex-col gap-2">
        {LINKS.map((l) => (
          <li key={l.href}>
            <Link
              to={l.href}
              className="group flex items-center gap-3 rounded-xl border border-border/60 bg-card p-4 shadow-[var(--shadow-bento)] transition-shadow duration-200 hover:border-border hover:shadow-[var(--shadow-bento-hover)]"
            >
              <div className="min-w-0 flex-1">
                <div className="text-sm font-semibold tracking-tight text-foreground transition-colors group-hover:text-primary">
                  {l.label}
                </div>
                <div className="text-xs text-muted-foreground">{l.meta}</div>
              </div>
              <IconExternalLink
                size={16}
                className="text-muted-foreground transition-colors group-hover:text-foreground"
              />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
